module.exports = __webpack_public_path__ + "img/loading_pedidos.5c89ba6f.jpg";